<template>
  <div>
    <div class="contsuc">
      <img class="" src="/static/img/success.png">
      <div>密码重置成功!</div>
    </div>
    <div class="loginbtdiv"><mt-button class="login-btn" size="large" type="primary" @click="goLogin()">立即登录</mt-button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui';
import cheader from '@/components/header';
import clogo from '@/components/logo';
export default {
  data () {
    return {
      inputType:'password'
    }
  },
  methods: {
    goLogin: function(){
      this.$router.push('/main');
    }
  },
  components:{
    cheader,
    clogo
  }
}
</script>

<style>
.contsuc{
  text-align: center;
  margin:80px 0 30px 0;
}
.contsuc img{
  width:70px;
}
.contsuc div{
  width:120px;
  margin: 10px auto;
  text-align: center;
  font-size: 18px;
  color: #37ba00;
}
.loginbtdiv{
  padding: 0 10px;
}
.login-btn{
    margin-top:15px;
}
</style>



// WEBPACK FOOTER //
// src/module/findpass/SetPassSuc.vue